import React from 'react';

/**
 * B2C Mom Layout — mobile-first, warm palette.
 * Centers content in a max-w-md container on larger screens to preserve
 * mobile-app feel. No sidebar — bottom nav is future phase.
 */
export const MomLayout = ({ children, className = '' }) => {
  return (
    <div className="min-h-screen bg-[#FFFAF8]" data-testid="mom-layout">
      <div className={`max-w-md mx-auto px-5 pt-6 pb-10 ${className}`}>
        {children}
      </div>
    </div>
  );
};

export default MomLayout;
